import React, { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  Container,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import Page from '../../../components/Layout/Page';
import useStyles from './styles';
import CustomHeader from '../../../components/General/CustomHeader';
import DevicesList from './component/Devices/DevicesList';
import SectorsList from './component/Sector/SectorsList';
import LayoutMap from './component/LayoutMap';
import CustomModal from '../../../components/General/CustomModal';
import UploadKMZ from './component/UploadKMZ';
import { PutSectorsKMZSchema } from '../../../requests/api/apiTypes';
import useFetchFarms from '../../../hooks/useFetchFarms';
import { ReduxState } from '../../../types';
import useGoogleMapsLoader from '../../../hooks/useGoogleMapsLoader';

const LayoutListView = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [openUploadKMZModal, setOpenUploadKMZModal] = useState<{
    open: boolean, data: null | Array<PutSectorsKMZSchema[string]>
  }>({ open: false, data: null });
  const [cdtecSector, setCdtecSector] = useState<null | string>(null);
  const [KMZSector, setKMZSector] = useState<null | PutSectorsKMZSchema[string]>(null);
  const [mappedSectors, setMappedSectors] = useState({});
  const { selectedFarm } = useSelector((state: ReduxState) => state.accountFarm);

  useFetchFarms();

  const handleCloseUploadKMZModal = () => {
    setCdtecSector(null);
    setKMZSector(null);
    setMappedSectors({});
    setOpenUploadKMZModal({ open: false, data: null });
  };

  const { isLoaded } = useGoogleMapsLoader();

  useEffect(() => {
    if (cdtecSector && KMZSector) {
      enqueueSnackbar('Sector asociado correctamente', { variant: 'success' });

      // Safely update the state outside of render
      setMappedSectors((prevState) => ({
        ...prevState,
        [cdtecSector]: { id: KMZSector.id, coordinates: KMZSector.coordinates },
      }));

      setCdtecSector(null);
      setKMZSector(null);
    }
  }, [cdtecSector, KMZSector, enqueueSnackbar]);

  if (!isLoaded) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Page
      className={classes.root}
      title={`Configuración ${selectedFarm?.name || 'Campo'}`}
    >
      <Container maxWidth={false} className={classes.containerContainer}>
        <CustomHeader title={`${selectedFarm?.name || 'Campo'}`} showBackButton={false} />
        <Box height='100%' display='flex' pt={3}>
          <Box marginRight='24px' className={classes.lateralListsContainer}>
            <SectorsList isLayout/>
          </Box>
          <LayoutMap
            setOpenUploadKMZModal={setOpenUploadKMZModal}
            setKMZSector={setKMZSector}
          />
          <Box marginLeft='24px' className={classes.lateralListsContainer}>
            <DevicesList />
          </Box>
        </Box>
      </Container>
      <CustomModal
        open={openUploadKMZModal.open}
        handleClose={handleCloseUploadKMZModal}
        cardClassName={classes.cardModalContainer}
      >
        <UploadKMZ
          handleCloseModal={handleCloseUploadKMZModal}
          polygons={openUploadKMZModal.data}
          KMZSector={KMZSector}
          mappedSectors={mappedSectors}
          cdtecSector={cdtecSector}
          setCdtecSector={setCdtecSector}
        />
      </CustomModal>
    </Page>
  );
};

export default LayoutListView;
